import {useLazyQuery} from '@apollo/client'
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Pagination,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap'
import {GET_ALL_VALIDATIONS} from '../../graphql/queries/validations'
import {EdgeValidations, IResAllValidations} from '../../graphql/types/validationsTypes'
import {useEffect, useMemo, useState} from 'react'
import {toast} from 'react-toastify'
import {BadgeStatus} from '../oneUser/components/activityTab/BadgeStatus'
import moment from 'moment'
import {Link} from 'react-router-dom'
import {parseId} from '../../helpers'
import {Tooltip} from 'react-tooltip'
import {DateRange} from 'react-date-range'
import {es} from 'date-fns/locale'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {isMobileDevice} from '../../../../_metronic/assets/ts/_utils'
import {useDisclosure} from '../../hooks/useDisclosure'
import {endOfDay, startOfMonth} from 'date-fns'
import {ModalAddValidation} from '../oneValidation/components/ModalAddValidation'
import {LoadingAllValidations} from './components/LoadingAllValidations'

type TStatus = 'CREADA' | 'EN_PROCESO' | 'EXITOSA' | 'ANULADA'

export const ValidationsPage = () => {
  const [gqlGetAll, {data, loading, error, refetch}] = useLazyQuery<IResAllValidations>(
    GET_ALL_VALIDATIONS,
    {fetchPolicy: 'no-cache'}
  )
  const isMobile = useMemo(() => isMobileDevice(), [])

  const {isOpen: isOpenCalendar, onClose: onCloseCalendar, onOpen: onOpenCalendar} = useDisclosure()
  const {isOpen: isOpenAdd, onClose: onCloseAdd, onOpen: onOpenAdd} = useDisclosure()

  const [dataTable, setDataTable] = useState<EdgeValidations[]>([])

  const [isOpenTool, setIsOpenTool] = useState(false)
  const [date, setDate] = useState([
    {
      startDate: startOfMonth(new Date()),
      endDate: new Date(),
      key: 'selection',
    },
  ])

  const [offset, setOffset] = useState(0)
  const [isPag, setIsPag] = useState(false)
  const [pag, setPag] = useState(1)
  const [first, setFirst] = useState(10)
  const [status, setStatus] = useState<TStatus | undefined>(undefined)
  const [valueSearch, setValueSearch] = useState('')
  const [filterPerson, setFilterPerson] = useState<{key: 'doc' | 'name'; value: string} | null>(
    null
  )

  useEffect(() => {
    const dates = date[0]
    const variables: {[k: string]: any} = {
      offset,
      first,
      status_Iexact: status,
    }
    if (filterPerson) {
      if (filterPerson.key === 'doc') {
        variables.documentNumber = filterPerson.value
      }
      if (filterPerson.key === 'name') {
        variables.name = filterPerson.value
      }
    }
    if (dates.startDate && dates.endDate) {
      variables.created_Gte = dates.startDate.toISOString()
      variables.created_Lte = endOfDay(dates.endDate).toISOString()
    }
    gqlGetAll({
      variables,
    })
  }, [gqlGetAll, offset, first, status, filterPerson, date])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    const {edges} = data.identityValidationList

    if (isPag) {
      setDataTable((p) => [...p, ...edges])
    } else {
      setDataTable(edges)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if ((loading || !data) && !isPag) {
    return <LoadingAllValidations />
  }

  const edges = data?.identityValidationList?.edges
  const pageInfo = data?.identityValidationList?.pageInfo

  console.log('pagiantioin', pag - 1 + offset, pag + first - 1)

  return (
    <div>
      <Card>
        <Card.Header>
          <Card.Title>Validaciones</Card.Title>
          <div className='card-title'>
            <Button size='sm' onClick={onOpenAdd}>
              <i className='bi bi-plus' style={{color: 'inherit'}} /> Agregar
            </Button>
          </div>
        </Card.Header>
        <Card.Body>
          <Row className='my-3 gap-x-2'>
            <Col sm={12} md={4} lg={5}>
              <form
                onSubmit={(e) => {
                  e.preventDefault()
                  setIsPag(true)
                  if (!valueSearch) {
                    setFilterPerson(null)
                    return
                  }
                  if (valueSearch.length < 3) return
                  const isNum = !isNaN(Number(valueSearch))

                  setFilterPerson({
                    key: isNum ? 'doc' : 'name',
                    value: valueSearch,
                  })
                }}
              >
                <InputGroup className='mb-3'>
                  <Form.Control
                    type='search'
                    value={valueSearch}
                    onChange={(e) => setValueSearch(e.target.value)}
                    placeholder='Nombre o No. documento'
                    aria-label='Buscar'
                    aria-describedby='basic-addon2'
                  />
                  <Button type='submit' variant='secondary' id='button-addon2'>
                    <i className='bi bi-search fs-2' />
                  </Button>
                </InputGroup>
              </form>
            </Col>
            <Col sm={12} md={8} lg={7}>
              <Row className='gap-md-0 gap-2'>
                <Col sm={12} md={6}>
                  <Form.Select
                    aria-label='Default select example'
                    value={status || ''}
                    onChange={(e) => {
                      console.log('e.target.value', e.target.value)
                      setStatus((e.target.value as TStatus) || undefined)
                      setIsPag(true)
                    }}
                  >
                    <option value=''>Estado</option>
                    {['CREADA', 'EN_PROCESO', 'EXITOSA', 'RECHAZADA', 'ANULADA'].map((st) => (
                      <option key={st} value={st}>
                        {st.replace('_', ' ')}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col sm={12} md={6}>
                  <Button
                    id='buttonId'
                    data-tooltip-id='buttonId'
                    variant='outline'
                    className='h-100 w-100'
                    style={{
                      fontSize: '13px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={() => {
                      if (isMobile) {
                        onOpenCalendar()
                        return
                      }
                      setIsOpenTool((p) => !p)
                    }}
                  >
                    {moment(date[0].startDate).format('DD/MM/YYYY')} -{' '}
                    {moment(date[0].endDate).format('DD/MM/YYYY')}
                  </Button>
                  <Tooltip
                    isOpen={isOpenTool}
                    id='buttonId'
                    place='bottom'
                    opacity={1}
                    style={{
                      backgroundColor: '#f8f8f8',
                      pointerEvents: isOpenTool ? 'all' : 'none',
                      zIndex: 9999999999,
                    }}
                  >
                    <div className='bg-white border'>
                      <DateRange
                        ranges={date}
                        locale={es}
                        months={isMobile ? 1 : 2}
                        onChange={(item) => {
                          console.log(item)
                          setIsPag(true)
                          setDate([item.selection])
                        }}
                        direction='horizontal'
                      />
                    </div>
                  </Tooltip>
                </Col>
              </Row>
            </Col>
          </Row>

          <Table responsive striped hover size='sm' style={{whiteSpace: 'nowrap'}}>
            <thead className='border-bottom-2'>
              <tr>
                <th className='fw-bold py-3' style={{minWidth: '20ch'}}>
                  Nombre
                </th>
                <th className='fw-bold py-3'>No. Identificación</th>
                <th className='fw-bold py-3'>Teléfono</th>
                <th className='fw-bold py-3'>Estado</th>
                <th className='fw-bold py-3'>Creada</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dataTable.slice(first * pag - first, first * pag).map(({node}) => (
                <tr key={node.id}>
                  <td className='text-uppercase'>
                    {parseId(node.id)}. -{node.firstName} {node.secondName || ''}{' '}
                    {node.firstSurname} {node.secondSurname || ''}
                  </td>
                  <td>
                    {node.documentType} {node.documentNumber}
                  </td>
                  <td>{node.phoneNumber}</td>
                  <td>
                    <BadgeStatus status={node.status} />
                  </td>
                  <td>{moment(node.created).format('DD MMM YYYY')}</td>
                  <td className='text-center'>
                    <Link
                      className='fw-semibold text-hover-primary'
                      to={`/validation/${parseId(node.id)}`}
                      target='_blank'
                    >
                      <i className='bi bi-eye fs-1' style={{color: 'inherit'}} />
                    </Link>
                  </td>
                </tr>
              ))}
              {edges == null && (
                <tr>
                  <td colSpan={6}>
                    <div className='d-flex flex-center' style={{height: '30vh'}}>
                      <Spinner animation='border' size='sm' />
                    </div>
                  </td>
                </tr>
              )}
              {edges?.length === 0 && (
                <tr>
                  <td colSpan={6}>
                    <div className='d-flex flex-center' style={{height: '30vh'}}>
                      No hay registradas validaciones
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className='d-flex align-items-center justify-content-between'>
            <div>
              <Form.Select
                aria-label='Total validaciones'
                size='sm'
                value={first}
                onChange={(e) => setFirst(Number(e.target.value))}
              >
                {[2, 3, 5, 10].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </Form.Select>
            </div>
            <Pagination>
              <Pagination.Prev
                className='border fs-1'
                as={Button}
                disabled={pag <= 1}
                onClick={() => {
                  setPag((p) => p - 1)
                }}
              />
              <Pagination.Item>{pag}</Pagination.Item>
              <Pagination.Next
                className='border fs-1'
                as={Button}
                disabled={!pageInfo?.hasNextPage && pag === Math.ceil(dataTable.length / first)}
                onClick={() => {
                  if (pag < Math.ceil(dataTable.length / first)) {
                    return setPag((p) => p + 1)
                  }
                  setOffset((p) => p + first)
                  setPag((p) => p + 1)
                  setIsPag(true)
                }}
              />
            </Pagination>
          </div>
        </Card.Body>
        {/* {isOpen && (
        <AddEditValidation isOpen={isOpen} onClose={onClose} refetch={refetch} id={info.id} />
      )} */}
      </Card>

      <Modal show={isOpenCalendar}>
        <Modal.Body>
          <div className='bg-white d-flex align-items-center justify-content-center'>
            <DateRange
              ranges={date}
              locale={es}
              months={1}
              onChange={(item) => {
                console.log(item)
                setIsPag(true)
                setDate([item.selection])
              }}
              direction='horizontal'
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCloseCalendar}>Aceptar</Button>
        </Modal.Footer>
      </Modal>

      {isOpenAdd && (
        <ModalAddValidation info={null} isOpen={isOpenAdd} onClose={onCloseAdd} refetch={refetch} />
      )}
    </div>
  )
}
